import { PropsWithChildren } from 'react';
import { Box } from '@mui/material';

import styles from './TabPanel.module.scss';

interface TabPanelProps {
  index: number;
  value: number;
}

const TabPanel = ({ children, value, index, ...props }: PropsWithChildren<TabPanelProps>) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      className={styles.container}
      {...props}
    >
      {value === index && <Box className={styles.content}>{children}</Box>}
    </div>
  );
};

export default TabPanel;
